import { useState, useCallback } from "react";
import { Form, useActionData, useLocation } from "react-router-dom";
import { Button, Input, Grid, Header, Message, Segment } from 'semantic-ui-react';

import { JoyyaHeader } from '../../components/JoyyaHeader';
import { PATHS } from '../../paths';

import styles from './MobileLoginView.module.css';

function MobileLoginView() {
  let location = useLocation();
  let params = new URLSearchParams(location.search);
  let from = params.get("from") || PATHS.ROOT;
  const [attemptedLogin, setAttemptedLogin] = useState(false);

  const setFailedTimer = useCallback(() => {
    setAttemptedLogin(false);
    const timer = setTimeout(() => {
      setAttemptedLogin(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, [setAttemptedLogin]);

  let actionData = useActionData() as { error: string } | undefined;

  return (
    <>
      <JoyyaHeader />
      <Grid textAlign='center' className={styles.grid} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450, top: '-2em' }}>
      {from.length > 1 && (<Message color='red'><p>You must log in to view the page at {from}</p></Message>)}
        <Header as='h1' textAlign='center'>
          <span className={styles.header}>Log in</span>
        </Header>
        <Form method="post" replace>
          <input type="hidden" name="redirectTo" value={from} />
            <Segment className={styles.loginInputSegment}>
              <Input
                fluid
                className={styles.loginInput}
                icon='user'
                iconPosition='left'
                placeholder='Username'
                control='input'
                name='username'
              />
              <br />
              <Input
                fluid
                className={styles.loginInput}
                icon='lock'
                iconPosition='left'
                name='password'
                placeholder='Password'
                type='password'
              />
              <br />
              {attemptedLogin && (<Message
                error
                header='Failed login'
                content='Check your password and username and try again.'
                                  />)}
              <Button
                style={{ backgroundColor: '#ed8a15', color: 'white', borderRadius: '10px', fontSize: '1.2em' }}
                type="submit" color='teal' fluid size='large' onClick={() => {
                  setFailedTimer()
                }}> {/* disabled={isLoggingIn}> */}
                Login
              </Button>
            </Segment>
          {actionData && actionData.error ? (
            <p style={{ color: "red" }}>{actionData.error}</p>
          ) : null}
        </Form>
        <div>
          <br/>
          <br/>
          <div className={styles.newToUs}>
            New to us?
          </div>
          <br />
          <Button style={{ width: '110px', fontSize: '1.2em' }} href={PATHS.SIGNUP}>
            Sign Up
          </Button>
        </div>
      </Grid.Column>
    </Grid>
    </>
  );
}

export { MobileLoginView }
